import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import StrengthsSection from "./StrengthsSection";
import ServicesSection from "./ServicesSection";
import RecruitCtaSection from "./RecruitCtaSection";
import NewsSection from "./NewsSection";
import ContactCtaSection from "./ContactCtaSection";
import FaqSection from "@/components/feature/FaqSection";
import { useSeo } from "@/hooks/useSeo";

const homeFaq = [
  {
    question: "GRANSTARKはどんな警備会社ですか？",
    answer: "株式会社GRANSTARKは2019年創業の大阪密着の警備会社です。大阪府公安委員会認定（第62003216号）を取得しており、交通誘導・高速道路・イベント（雑踏）・施設警備の4分野に対応しています。",
  },
  {
    question: "GRANSTARKに警備を依頼するにはどうすればいいですか？",
    answer: "お電話（06-6786-9252）またはホームページのお問い合わせフォームからご連絡ください。最短即日でご対応いたします。",
  },
  {
    question: "対応エリアはどこですか？",
    answer: "主に大阪府内全域に対応しています。",
  },
];

export default function Home() {
  useSeo({
    title: "大阪の警備会社なら株式会社GRANSTARK｜交通誘導・イベント・高速道路警備",
    description:
      "大阪府公安委員会認定の警備会社。交通誘導・雑踏警備・高速道路警備・施設警備に対応。難波事務所より大阪・関西全域へ出動。警備のご依頼・お見積もりはお気軽にご相談ください。",
    ogUrl: "https://www.gs-granstark.com/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.gs-granstark.com/#webpage",
        url: "https://www.gs-granstark.com/",
        name: "大阪の警備会社なら株式会社GRANSTARK｜交通誘導・イベント・高速道路警備",
        description:
          "大阪府公安委員会認定の警備会社。交通誘導・雑踏警備・高速道路警備・施設警備に対応。難波事務所より大阪・関西全域へ出動。警備のご依頼・お見積もりはお気軽にご相談ください。",
        isPartOf: { "@id": "https://www.gs-granstark.com/#website" },
        publisher: { "@id": "https://www.gs-granstark.com/#business" },
        inLanguage: "ja",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://www.gs-granstark.com/#organization",
        name: "株式会社GRANSTARK",
        alternateName: "グランシュターク",
        url: "https://www.gs-granstark.com",
        telephone: "06-6786-9252",
        address: {
          "@type": "PostalAddress",
          streetAddress: "難波中3-9-3 南朝日ビル804号",
          addressLocality: "大阪市浪速区",
          addressRegion: "大阪府",
          postalCode: "556-0003",
          addressCountry: "JP",
        },
        areaServed: ["大阪府", "関西"],
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "警備サービス",
          itemListElement: [
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "交通誘導警備" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "雑踏警備" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "イベント警備" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "高速道路警備" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "施設警備" } },
          ],
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: homeFaq.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      },
    ],
  });

  return (
    <div>
      <HeroSection />
      <AboutSection />
      <StrengthsSection />
      <ServicesSection />
      <RecruitCtaSection />
      <NewsSection />
      <ContactCtaSection />
      <FaqSection items={homeFaq} bgColor="bg-gray-50" />
    </div>
  );
}
